import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

// A single scrolling surface; each level remembers its own position.
export default function MobileNavigation({ menu, columns, theme, isDarkMode = false, onSelect, onClose }) {
  const [path, setPath] = useState([]);
  const panelRef = useRef(null);
  useLayoutEffect(() => {
    const viewport = window.visualViewport;
    const resize = () => {
      // Use the visible viewport, including browser toolbar/keyboard changes.
      const top = document.querySelector('.site-header-inner')?.getBoundingClientRect().bottom || 56;
      const bottom = (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight);
      panelRef.current.style.top = `${top}px`;
      panelRef.current.style.height = `${Math.max(0, bottom - top)}px`;
    };
    resize();
    window.addEventListener('resize', resize);
    viewport?.addEventListener('resize', resize);
    viewport?.addEventListener('scroll', resize);
    return () => {
      window.removeEventListener('resize', resize);
      viewport?.removeEventListener('resize', resize);
      viewport?.removeEventListener('scroll', resize);
    };
  }, []);
  const listRef = useRef(null);
  const backRef = useRef(null);
  const positions = useRef({});
  const active = path[path.length - 1];
  const levelKey = path.map(item => item.id).join('/') || 'root';
  useLayoutEffect(() => {
    listRef.current.scrollTop = positions.current[levelKey] || 0;
  }, [levelKey]);
  const enter = item => {
    if (item.children?.length) {
      positions.current[levelKey] = listRef.current.scrollTop;
      setPath(previous => [...previous, item]);
      backRef.current?.focus({ preventScroll: true });
    } else onSelect(item);
  };
  const back = () => {
    positions.current[levelKey] = listRef.current.scrollTop;
    setPath(previous => previous.slice(0, -1));
  };
  const sections = active ? [{ category: `${active.title} · ${path.length === 1 ? '城市' : '具體地點'}`, items: active.children }] : columns;
  return createPortal(<section ref={panelRef} onClick={event => event.stopPropagation()} className="mobile-navigation" aria-label={`${menu} 選單`} style={{ background: isDarkMode ? '#121214' : '#fbfbfd', color: theme.textPrimary, '--menu-border': theme.cardBorder, '--menu-secondary': theme.textSecondary }} onKeyDown={event => { if (event.key === 'Escape') { event.stopPropagation(); onClose(); } }}>
    <div className="mobile-navigation-toolbar">
      <button ref={backRef} type="button" onClick={active ? back : onClose} aria-label={active ? '返回上一級' : '收起選單'}>{active ? '← 返回' : '收起'}</button>
      <strong>{active?.title || menu}</strong>
      <button type="button" aria-label="關閉選單" onClick={onClose}>✕</button>
    </div>
    <div ref={listRef} className="mobile-navigation-list">
      {active && <button className="mobile-navigation-all" type="button" onClick={() => onSelect(active)}>查看{active.title}全部作品 <span aria-hidden="true">↗</span></button>}
      {sections.map(section => <div key={section.category} className="mobile-navigation-section">
        <h3>{section.category}</h3>
        {section.items.map(item => <button type="button" className="mobile-navigation-item" key={item.id} onClick={() => enter(item)}>
          <span><strong>{item.title}</strong><small>{item.desc}</small></span>
          <span aria-hidden="true">{item.children?.length ? '›' : '↗'}</span>
        </button>)}
      </div>)}
    </div>
  </section>, document.body);
}
